module.exports = __webpack_public_path__ + "static/img/vod-bn-5.bf32485.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vod-bn-5.jpg
// module id = s0Lg
// module chunks = 1